var CurrentRefSection;
var HowManyMaxDisplayRef = 5;
var LimitLeftShowVoucherTrade = 100;

// ALL ELEMENTS ------------------------------------------------------
var TotalPoinHeaderText;
var TotalPoinInfoText;

var MemberPoinHeaderText;
var MemberPoinInfoText;

var PingPoinHeaderText;
var PingPoinInfoText;

var ViewAllHyperlinkText;

var HistoryContainerRefMenu;

var RefMenuHowManyText;
var RefMenuHeaderText;
var RefMenuMessageText;

var ShareReferralInputContainer;
var CopyIdTextRefMenu;
var ShareButtonRefMenu;
var ShareButtonWrapperRefMenu;
var ShareReferralBtnText;
var ShareReferralBtnMid2Text;

var BelumAdaMenginapContainer;
var BelumAdaYangMenginapHeaderText;
var BelumAdaYangMenginapMessageText;

var ReffTableContainer;
var ReffTableTBody;

var TukarPointButton;
var TukarPointButtonWrapper;
var TukarPointButtonText;

var CaraMudahNginepGratisText;
var ReferralStep1Header;
var ReferralStep1Message;

var ReferralStep2Header;
var ReferralStep2Message;

var ReferralStep3Header;
var ReferralStep3Message;

var ListOfSlideImages = ["/Assets/images/ReferralHeaderImages/1.jpg", "/Assets/images/ReferralHeaderImages/2.jpg"];

// PREPARE ALL ELEMENTS ============================================

window.PrepareVarforAllUI = function()
{
    // Left --------------------------------------------------------------------------------------------
    if(document.getElementById("TotalPoinHeaderText") != null)
    {
        document.getElementById("TotalPoinHeaderText").innerHTML = window["TotalPoinHeaderTxt" + window.CurrentCountryID] + ":";
    }

    if(document.getElementById("MemberPoinHeaderText") != null)
    document.getElementById("MemberPoinHeaderText").innerHTML = window["MemberPointTxt" + window.CurrentCountryID] + " (" + window["MemberPointAbrTxt" + window.CurrentCountryID] +")";
    
    if(document.getElementById("PingPoinHeaderText") != null)
    document.getElementById("PingPoinHeaderText").innerHTML = window["PingPointTxt" + window.CurrentCountryID] + " (" + window["PingPointAbrTxt" + window.CurrentCountryID] +")";

    if(document.getElementById("ViewAllHyperlinkText") != null)
    document.getElementById("ViewAllHyperlinkText").innerHTML = window["ViewAllTxt" + window.CurrentCountryID];

    if(document.getElementById("HistoryPointHeaderText") != null)
    document.getElementById("HistoryPointHeaderText").innerHTML = window["HistoryPointTxt" + window.CurrentCountryID];

    // Right --------------------------------------------------------------------------------------------
    if(document.getElementById("ShareReferralBtnText") != null)
    document.getElementById("ShareReferralBtnText").innerHTML = window["ShareReferralTxt" + window.CurrentCountryID];

    if(document.getElementById("ShareReferralBtnShowDP2Text") != null)
        document.getElementById("ShareReferralBtnShowDP2Text").innerHTML = window["ShareTxt" + window.CurrentCountryID];

    if(document.getElementById("AjakTemenDoubleCuanButtonText") != null)
    document.getElementById("AjakTemenDoubleCuanButtonText").innerHTML = window["AjakTemenDoubleCuanTxt" + window.CurrentCountryID];

    // Swiper  ------------------------------------------------

    let LoadingImageBackground = document.getElementById("LoadingImageBackground");
    let RefSwiperBackground = document.getElementById("RefSwiperBackground");
    RefSwiperBackground.src = ListOfSlideImages[0];

    let ReferralSwiperSlideWrapper = document.getElementById("ReferralSwiperSlideWrapper");
    ReferralSwiperSlideWrapper.innerHTML = "";

    let ImagesSlideToLoad = [];

    for(let i = 0; i < ListOfSlideImages.length; i++)
    {
        let ReferralSwiperSlide = document.createElement("div");
        ReferralSwiperSlide.className = "ReferralSwiperSlide swiper-slide";
        ReferralSwiperSlideWrapper.append(ReferralSwiperSlide);

        let wrapperRefMenu = document.createElement("div");
        wrapperRefMenu.className = "image-wrapperRefMenu";
        ReferralSwiperSlide.append(wrapperRefMenu);

        let LoadingBlocker = document.createElement("div");
        LoadingBlocker.className = "loading-blockerRefMenu loading_grey";
        wrapperRefMenu.append(LoadingBlocker);

        let SlideImagesImg = document.createElement("img");
        window.checkImageUrlValid(ListOfSlideImages[i], "/Assets/images/NoHotelImage.jpg", SlideImagesImg, () =>{}, {});
        wrapperRefMenu.append(SlideImagesImg);

        ImagesSlideToLoad.push(SlideImagesImg);
    }

    window.HandleAllImageLoadWithFunction(ImagesSlideToLoad, function()
    {
        let LoadingSlides = [...ReferralSwiperSlideWrapper.getElementsByClassName('loading-blockerRefMenu')];

        LoadingSlides.forEach(ThisElement =>
        {
            ThisElement.remove();
        });

        LoadingImageBackground.remove();
        RefSwiperBackground.style.opacity = 1;
    })

    let swiperWrapper = new window.Swiper('.ReferralSwiperSlideContainer',
    {
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: 1,
        observer: true,
        observeParents: true,
        loop:true,
        pagination:
        {
            el: '.swiper-pagination',
            clickable: true,
        },
        navigation:
        {
            nextEl: ".PopularAreaButtonRight",
            prevEl: ".PopularAreaButtonLeft",
        },
        autoplay:
        {
            delay: 15000,
        }
    });
    swiperWrapper.on('realIndexChange', function ()
    {
        //console.log(swiperWrapper.realIndex);
        RefSwiperBackground.src = ImagesSlideToLoad[swiperWrapper.realIndex].src;
    });

    // CHECK STEP IMAGE ===============================

    CheckImagesLoadedBasicUIRef()
}

function AsignUIRefVariable()
{
    // Total Poin ------------------------------------
    TotalPoinHeaderText = document.getElementById("TotalPoinHeaderText");
    TotalPoinInfoText = document.getElementById("TotalPoinInfoText");

    // Member Poin ------------------------------------
    MemberPoinHeaderText = document.getElementById("MemberPoinHeaderText");
    MemberPoinInfoText = document.getElementById("MemberPoinInfoText");

    // Ping Poin ------------------------------------
    PingPoinHeaderText = document.getElementById("PingPoinHeaderText");
    PingPoinInfoText = document.getElementById("PingPoinInfoText");

    // View All Hyperlink ---------------------------------
    ViewAllHyperlinkText = document.getElementById("ViewAllHyperlinkText");

    // Left Bottom History Point ======================================================================================
    HistoryContainerRefMenu = document.getElementById("HistoryContainerRefMenu");

    // Right Section ======================================================================================
    RefMenuHowManyText = document.getElementById("RefMenuHowManyText");
    RefMenuHeaderText = document.getElementById("RefMenuHeaderText");
    RefMenuMessageText = document.getElementById("RefMenuMessageText");

    ShareReferralInputContainer = document.getElementById("ShareReferralInputContainer");

    CopyIdTextRefMenu = document.getElementById("CopyIdTextRefMenu");

    ShareButtonRefMenu = document.getElementById("ShareButtonRefMenu");
    ShareButtonWrapperRefMenu = document.getElementById("ShareButtonWrapperRefMenu");
    ShareReferralBtnText = document.getElementById("ShareReferralBtnText");
    ShareReferralBtnMid2Text = document.getElementById("ShareReferralBtnShowDP2Text");

    BelumAdaMenginapContainer = document.getElementById("BelumAdaMenginapContainer");

    BelumAdaYangMenginapHeaderText = document.getElementById("BelumAdaYangMenginapHeaderText");
    BelumAdaYangMenginapMessageText = document.getElementById("BelumAdaYangMenginapMessageText");

    ReffTableContainer = document.getElementById("ReffTableContainer");

    ReffTableTBody = document.getElementById("ReffTableTBody");

    TukarPointButton = document.getElementById("TukarPointButton");
    TukarPointButtonWrapper = document.getElementById("TukarPointButtonWrapper");
    TukarPointButtonText = document.getElementById("TukarPointButtonText");

    CaraMudahNginepGratisText = document.getElementById("CaraMudahNginepGratisText");
    ReferralStep1Header = document.getElementById("ReferralStep1Header");
    ReferralStep1Message = document.getElementById("ReferralStep1Message");

    ReferralStep2Header = document.getElementById("ReferralStep2Header");
    ReferralStep2Message = document.getElementById("ReferralStep2Message");

    ReferralStep3Header = document.getElementById("ReferralStep3Header");
    ReferralStep3Message = document.getElementById("ReferralStep3Message");
}


// LOAD DATA =================================================

window.LoadAllRefData = function(mainsession, basicinfo, loggedin)
{
    // Set Basic UI Variable -------------------------------------------------

    AsignUIRefVariable()
    
    // CHECK STEP IMAGE ===============================
    window.ChangeRefMenuSection('AjakTemen', mainsession, loggedin);

    // Set Filter Button ------------------------------------
    document.getElementById("AjakTemenSectionButton").onclick = function()
    {
        window.ChangeRefMenuSection('AjakTemen', mainsession, loggedin);
    }

    document.getElementById("NginepGratisSectionButton").onclick = function()
    {
        window.ChangeRefMenuSection('NginepGratis', mainsession, loggedin);
    }

    // Load Basic Info ------------------------------------------------

    if(loggedin == true)
    {
        let LoadDataBlocker = window.InstantiateLoadingBlocker("LoadBasicInfoBlocker");
        SetLoadingLeftSection();


        // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! USER POINT !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

        // Point Info Left ------------------------------------------------------------------
        
        let HistoryPointUserURL = "/v2/users/" + mainsession.usd_PING_id + "/points/history";

        window.CallApiAxios({
            method: "GET",
            url: HistoryPointUserURL,
        }).then(res =>
        {
            //console.log(HistoryPointUserURL);

            if(res.status == 200)
            {
                let HistoryPointData = res.data.data;
                //console.log(HistoryPointData);

                let UserPointData = HistoryPointData.user.member_pings;
                let RewardHistoryDataUser = HistoryPointData.history_points;

                // Set View All ------------------------

                ViewAllHyperlinkText.style.display = "";
                ViewAllHyperlinkText.onclick = function()
                {
                    OpenViewAllHistoryPanel(RewardHistoryDataUser, mainsession, basicinfo, loggedin);
                }
                
                UpdateBasicReferralInfo(UserPointData, RewardHistoryDataUser, mainsession, basicinfo, loggedin);
            }
        })
        .catch(err =>
        {
            //console.error(err);
        });
        LoadDataBlocker.remove();
    }
}

function UpdateBasicReferralInfo(UserPointData, RewardHistoryDataUser, mainsession, basicinfo, loggedin)
{
    // Basic Poin Info -----------------------------------------

    TotalPoinHeaderText.style.color = "#2494D9"; // Total Poin ---------
    TotalPoinHeaderText.className = "LabelGreyHeaderText InterExBoldTextFont ShowAfterLeftSection";

    TotalPoinInfoText.style.color = "#ED7C42";
    TotalPoinInfoText.className = "LabelGreyHeaderText InterBoldTextFont ShowAfterLeftSection";
    TotalPoinInfoText.innerHTML = (UserPointData.ref_ping_counts_now + UserPointData.ref_member_counts_now) + " <img src='/Assets/images/ButtonIcon/coin-icon.svg'>";

    MemberPoinHeaderText.style.color = "#2494D9"; // Member Poin ---------
    MemberPoinHeaderText.className = "LabelGreyHeaderSmallerText InterMediumTextFont ShowAfterLeftSection";

    MemberPoinInfoText.style.color = "#ED7C42";
    MemberPoinInfoText.className = "LabelGreyHeaderSmallerText InterMediumTextFont ShowAfterLeftSection";
    MemberPoinInfoText.innerHTML = UserPointData.ref_member_counts_now;

    PingPoinHeaderText.style.color = "#2494D9"; // Ping Poin ---------
    PingPoinHeaderText.className = "LabelGreyHeaderSmallerText InterMediumTextFont ShowAfterLeftSection";

    PingPoinInfoText.style.color = "#ED7C42";
    PingPoinInfoText.className = "LabelGreyHeaderSmallerText InterMediumTextFont ShowAfterLeftSection";
    PingPoinInfoText.innerHTML = UserPointData.ref_ping_counts_now;

    TukarPointButton.className = "BasicTextButton BasicBoxShadow OrangeButton SignInButtonTop Selectable";
    TukarPointButton.onclick = function()
    {
        InstantiateTukarPointMenu(UserPointData, mainsession, basicinfo, loggedin);
    }
    TukarPointButtonWrapper.style.opacity = 1;

    // History Reward Instantiate --------------------------------------------
    
    let HistoryPointList = RewardHistoryDataUser;
    if(Array.isArray(HistoryPointList))
    {
        HistoryPointList = HistoryPointList.slice(0, HowManyMaxDisplayRef);
    }
    HistoryContainerRefMenu.innerHTML = "";
    InstantiateHistoryPanel(HistoryPointList, HistoryContainerRefMenu, "white");

    // User Referral Code ----------------------------------

    ShareButtonRefMenu.className = "BasicTextButton BasicBoxShadow OrangeButton SignInButtonTop SelectableOnlyContentAnim";
    ShareButtonWrapperRefMenu.style.opacity = 1;

    CopyIdTextRefMenu.className = "LabelGreyHeaderSmallerText2 InterRegularTextFont CopyText";
    CopyIdTextRefMenu.style.color = "#1D2939";

    if(UserPointData.id_referral != null)
    {
        CopyIdTextRefMenu.innerHTML = UserPointData.id_referral + " <img class='Selectable2' src='/Assets/images/ButtonIcon/copy-grey.svg' id='CopyRefIconButton' ;>";
        document.getElementById("CopyRefIconButton").onclick = function()
        {
            window.CopyToClipboardItem(UserPointData.id_referral);
        }

        ShareButtonRefMenu.onclick = function()
        {
            // Function To Call For Prepare And Send Referral --------------------------

            let FunctionToCall = ()=>
            {
                window.InstantiateSharePanel("Share Referral", "Ask to Join PinginGo", "Share Referral Success", "Referral", '', '', '', loggedin);
            }

            let CheckURLGET = "/function/show_referral_member.php?id_user=" + UserPointData.id_user;
            let PushCreatedShareURL = "/function/upload_referral_img.php";

            window.ShareURL = UserPointData.id_referral;

            let formData = new FormData();
            formData.append('id_referral', UserPointData.id_referral);

            window.CheckShareImageExist(CheckURLGET, "/Assets/Ref-PinginGo.jpg", PushCreatedShareURL, "UserReferral", formData, FunctionToCall);
        }
    }
    else
    {
        CopyIdTextRefMenu.innerHTML = "ERROR!";
        ShareButtonRefMenu.onclick = function ()
        {
            alert("An error occurred when retrieving the Referral ID, please contact the administrator.");
        };
    }
}


// INSTANTIATE HISTORY PANEL ===================================

function InstantiateHistoryPanel(HistoryPointList, wheretoinstantiate, bgcolor)
{
    // If Instantiated Data Less Than The Maximum Instantiate Blank Until it Fills ------------------------
    let HowManyInstantiated = HistoryPointList.length;
    if(HowManyMaxDisplayRef > HowManyInstantiated)
    {
        for(let i = HowManyInstantiated; i < HowManyMaxDisplayRef; i++)
        {
            let DummyData = {
                "id_history_point": null,
                "point_quantity": "1",
                "point_types": null,
                "status_point": null,
                "status_add_subs_point": null,
                "history_desc": "------",
                "create_at": null
            }
            HistoryPointList.push(DummyData);
        }
    }

    for(let i = 0; i < HistoryPointList.length; i++)
    {
        let PriceMainTextWrapper = document.createElement("div");
        PriceMainTextWrapper.className = "PriceMainTextWrapper WhiteContainerPrice BasicRoundRadius";
        PriceMainTextWrapper.style.backgroundColor = bgcolor;
        wheretoinstantiate.append(PriceMainTextWrapper);

        let DateAndTimeWrapper = document.createElement("div");
        DateAndTimeWrapper.className = "Price1stWrapper";
        DateAndTimeWrapper.style.width = "35%";
        PriceMainTextWrapper.append(DateAndTimeWrapper);

        let DateTextP = document.createElement("p");
        DateTextP.className = "LabelGreyHeaderSmallerText InterMediumTextFont";
        DateTextP.style.color = "#101828";
        DateAndTimeWrapper.append(DateTextP);

        let TimeTextWrapper = document.createElement("div");
        TimeTextWrapper.className = "PoinWithIconWrapper";
        TimeTextWrapper.style.marginLeft = 0;
        DateAndTimeWrapper.append(TimeTextWrapper);

        let TimeTextP = document.createElement("p");
        TimeTextP.className = "SmallerRoomDescriptionText InterRegularTextFont";
        TimeTextP.style.color = "#667085";
        TimeTextWrapper.append(TimeTextP);

        if(HistoryPointList[i].create_at != null)
        {
            let WhichDate = HistoryPointList[i].create_at;
            if(HistoryPointList[i].create_update_at != null)
                WhichDate = HistoryPointList[i].create_update_at;

            let ThisDateNTimeArray = WhichDate.split(" ");
            let ThisDateArray = ThisDateNTimeArray[0].split("-");
            let ThisTimeArray = ThisDateNTimeArray[1].split(":");

            DateTextP.innerHTML = ThisDateArray[2] + " " + window["monthNames" + window.CurrentCountryID][parseInt(ThisDateArray[1])-1] + " " + ThisDateArray[0];
            TimeTextP.innerHTML = ThisTimeArray[0] + ":" + ThisTimeArray[1];
        }
        else
        {
            DateTextP.innerHTML = "-- --- ----";
            TimeTextP.innerHTML = "-- --- ----";
        }

        let NameAndTotalPoinWrapper = document.createElement("div");
        NameAndTotalPoinWrapper.className = "Price2ndWrapper";
        NameAndTotalPoinWrapper.style.width = "60%";
        NameAndTotalPoinWrapper.style.overflow = "hidden";
        NameAndTotalPoinWrapper.style.display = "hidden";
        NameAndTotalPoinWrapper.style.flexDirection = "column";
        PriceMainTextWrapper.append(NameAndTotalPoinWrapper);

        let NameTextP = document.createElement("p");
        NameTextP.className = "LabelGreyHeaderSmallerText InterMediumTextFont";
        NameTextP.style.color = "#000000";
        NameTextP.style.width = "100%";
        NameTextP.style.textAlign = "end";
        NameTextP.style.textOverflow = "ellipsis";
        NameTextP.style.overflow = "hidden";
        NameTextP.style.whiteSpace = "nowrap";
        NameTextP.innerHTML = HistoryPointList[i].history_desc;
        NameAndTotalPoinWrapper.append(NameTextP);

        let TotalPoinWrapper = document.createElement("div");
        TotalPoinWrapper.className = "PoinWithIconWrapper";
        TotalPoinWrapper.style.marginLeft = "auto";
        NameAndTotalPoinWrapper.append(TotalPoinWrapper);

        let TotalPoinP = document.createElement("p");
        TotalPoinP.className = "SmallerRoomDescriptionText InterMediumTextFont";
        TotalPoinP.style = "margin-top: auto; margin-bottom: auto; margin-right: 0;";
        TotalPoinWrapper.append(TotalPoinP);

        if(HistoryPointList[i].status_point != null)
        {
            let PointValueAndType = window.DetermineWhichPoinNameWithValue(HistoryPointList[i].point_quantity, HistoryPointList[i].point_types) + "<img src='/Assets/images/ButtonIcon/coin-icon.svg'>";
            if(HistoryPointList[i].status_point == "Add")
            {
                TotalPoinP.innerHTML = "+" + PointValueAndType;
                TotalPoinP.style.color = "#0b0e11";
            }
            else if(HistoryPointList[i].status_point == "Refund")
            {
                TotalPoinP.innerHTML = PointValueAndType;
                TotalPoinP.style.color = "#626B79";
            }
            else
            {
                TotalPoinP.innerHTML = "-" + PointValueAndType;
                TotalPoinP.style.color = "#F04438";
            }
        }
        else
        {
            TotalPoinP.innerHTML = "----";
            TotalPoinP.style.color = "#0b0e11";
        }
    }
}


// LOADING BASIC INFO IN REF MENU =====================================

function SetLoadingLeftSection()
{
    // Left Top Total Point ======================================================================================
    
    // Total Poin ------------------------------------
    TotalPoinHeaderText.style.color = "transparent";
    TotalPoinHeaderText.className = "LabelGreyHeaderText InterExBoldTextFont ShowAfterLeftSection loading_grey";

    TotalPoinInfoText.style.color = "transparent";
    TotalPoinInfoText.className = "LabelGreyHeaderText InterBoldTextFont ShowAfterLeftSection loading_grey";
    TotalPoinInfoText.innerHTML = "-- ---";

    // Member Poin ------------------------------------
    MemberPoinHeaderText.style.color = "transparent";
    MemberPoinHeaderText.className = "LabelGreyHeaderSmallerText InterMediumTextFont ShowAfterLeftSection loading_grey";

    MemberPoinInfoText.style.color = "transparent";
    MemberPoinInfoText.className = "LabelGreyHeaderSmallerText InterMediumTextFont ShowAfterLeftSection loading_grey";

    // Ping Poin ------------------------------------
    PingPoinHeaderText.style.color = "transparent";
    PingPoinHeaderText.className = "LabelGreyHeaderSmallerText InterMediumTextFont ShowAfterLeftSection loading_grey";

    PingPoinInfoText.style.color = "transparent";
    PingPoinInfoText.className = "LabelGreyHeaderSmallerText InterMediumTextFont ShowAfterLeftSection loading_grey";

    // Tukar Poin ------------------------------------
    TukarPointButton.className = "BasicTextButton BasicBoxShadow OrangeButton SignInButtonTop loading_grey";
    TukarPointButton.onclick = function(){};
    TukarPointButtonWrapper.style.opacity = 0;

    // Left Bottom History Point ======================================================================================
    HistoryContainerRefMenu.innerHTML = "";

    for(let i = 0; i < 5; i++)
    {
        InstantiateHistoryLoadingPanel(HistoryContainerRefMenu, "white");
    }

    // Ref Code (Right) -----------------------------

    CopyIdTextRefMenu.innerHTML = "------------ ---";
    CopyIdTextRefMenu.className = "LabelGreyHeaderSmallerText2 InterRegularTextFont CopyText loading_grey";
    CopyIdTextRefMenu.style.color = "transparent";

    ShareButtonRefMenu.className = "BasicTextButton BasicBoxShadow OrangeButton SignInButtonTop loading_grey";

    ShareButtonWrapperRefMenu.style.opacity = 0;
}

function InstantiateHistoryLoadingPanel(wheretoinstantiate, whatbgcolor)
{
    let PriceMainTextWrapper = document.createElement("div");
    PriceMainTextWrapper.className = "PriceMainTextWrapper WhiteContainerPrice BasicRoundRadius";
    PriceMainTextWrapper.backgroundColor = whatbgcolor;
    wheretoinstantiate.append(PriceMainTextWrapper);

    let DateAndTimeWrapper = document.createElement("div");
    DateAndTimeWrapper.className = "Price1stWrapper";
    PriceMainTextWrapper.append(DateAndTimeWrapper);

    let DateTextP = document.createElement("p");
    DateTextP.className = "LabelGreyHeaderSmallerText InterMediumTextFont loading_grey";
    DateTextP.style.color = "transparent";
    DateTextP.innerHTML = "01-01-2000";
    DateAndTimeWrapper.append(DateTextP);

    let TimeTextWrapper = document.createElement("div");
    TimeTextWrapper.className = "PoinWithIconWrapper";
    TimeTextWrapper.style.marginLeft = 0;
    DateAndTimeWrapper.append(TimeTextWrapper);

    let TimeTextP = document.createElement("p");
    TimeTextP.className = "SmallerRoomDescriptionText InterRegularTextFont loading_grey";
    TimeTextP.style.color = "transparent";
    TimeTextP.innerHTML = "00:00";
    TimeTextWrapper.append(TimeTextP);

    let NameAndTotalPoinWrapper = document.createElement("div");
    NameAndTotalPoinWrapper.className = "Price2ndWrapper";
    PriceMainTextWrapper.append(NameAndTotalPoinWrapper);

    let NameTextP = document.createElement("p");
    NameTextP.className = "LabelGreyHeaderSmallerText InterMediumTextFont loading_grey";
    NameTextP.style.color = "transparent";
    NameTextP.innerHTML = "------";
    NameAndTotalPoinWrapper.append(NameTextP);

    let TotalPoinWrapper = document.createElement("div");
    TotalPoinWrapper.className = "PoinWithIconWrapper";
    TotalPoinWrapper.style.marginLeft = "auto";
    NameAndTotalPoinWrapper.append(TotalPoinWrapper);

    let TotalPoinP = document.createElement("p");
    TotalPoinP.className = "SmallerRoomDescriptionText InterRegularTextFont loading_grey";
    TotalPoinP.style = "color: transparent; margin-top: auto; margin-bottom: auto;";
    TotalPoinP.innerHTML = "0 ---- ----";
    TotalPoinWrapper.append(TotalPoinP);

    return PriceMainTextWrapper;
}

function SetLoadingRightSection()
{
    // Right Section ======================================================================================
    RefMenuHowManyText.innerHTML = "--";

    BelumAdaMenginapContainer.style.display = "none";

    ReffTableContainer.style.display = "";

    ReffTableTBody.innerHTML = "";

    for(let i = 0; i < HowManyMaxDisplayRef; i++)
    {
        InstantiateRightSectionHistoryLoading(ReffTableTBody);
    }
}

function InstantiateRightSectionHistoryLoading(wheretoinstantiate)
{
    let LoadingHistoryTr = document.createElement("tr");
    wheretoinstantiate.append(LoadingHistoryTr);

    let UserProfileTD = document.createElement("td"); // User Profile ---------
    UserProfileTD.style.width = "35%";
    LoadingHistoryTr.append(UserProfileTD);

    let UserProfileWrapper = document.createElement("div");
    UserProfileWrapper.className = "ReffTableTDWrapper";
    UserProfileTD.append(UserProfileWrapper);

    let UserTopProfileIcon = document.createElement("div");
    UserTopProfileIcon.className = "UserTopProfileIcon";
    UserProfileWrapper.append(UserTopProfileIcon);

    let UserTopProfileLoading = document.createElement("div");
    UserTopProfileLoading.className = "loading_grey";
    UserTopProfileLoading.style = "width: 100%; height: 100%;";
    UserTopProfileIcon.append(UserTopProfileLoading);

    let UserNameLoading = document.createElement("div");
    UserNameLoading.className = "RoomSmallInfo loading_grey";
    UserNameLoading.style = "margin: auto 0; width: 70%;"
    UserProfileWrapper.append(UserNameLoading);

    if(CurrentRefSection == "AjakTemen")
    {
        UserProfileTD.style.width = "100%";
        UserNameLoading.style.width = "50%";
    }
    else
    {
        let DateTD = document.createElement("td"); // Date ---------
        DateTD.style.width = "25%";
        LoadingHistoryTr.append(DateTD);

        let DateWrapper = document.createElement("div");
        DateWrapper.className = "ReffTableTDWrapper";
        DateTD.append(DateWrapper);

        let DateLoading = document.createElement("div");
        DateLoading.className = "RoomSmallInfo loading_grey";
        DateLoading.style = "margin: auto 0; width: 50%;"
        DateWrapper.append(DateLoading);

        let LocationTD = document.createElement("td"); // Location ---------
        LocationTD.style.width = "40%";
        LoadingHistoryTr.append(LocationTD);

        let LocationWrapper = document.createElement("div");
        LocationWrapper.className = "ReffTableTDWrapper";
        LocationTD.append(LocationWrapper);

        let LocationLoading = document.createElement("div");
        LocationLoading.className = "RoomSmallInfo loading_grey";
        LocationLoading.style = "margin: auto 0; width: 30%;"
        LocationWrapper.append(LocationLoading);
    }

    return LoadingHistoryTr;
}



// CHECK IMAGES STEPS LOADED PROPERLY =====================================

function CheckImagesLoadedBasicUIRef()
{
    // Step Images -------------------
    let PingHowToStepRefMenuContainer = document.getElementById("PingHowToStepRefMenuContainer");
    let StepImages = [...PingHowToStepRefMenuContainer.getElementsByTagName('img')];

    let ShowAfterStepSection = document.querySelectorAll(".ShowAfterStepSection");
    let HideAfterStepSection = document.querySelectorAll(".HideAfterStepSection");
    let RemoveClassAfrerStepSection = document.querySelectorAll(".RemoveClassAfrerStepSection");

    window.HandleAllImageLoadWithFunction(StepImages, function()
    {
        ShowAfterStepSection.forEach(ThisElement =>
        {
            ThisElement.style.display = "";
        });

        HideAfterStepSection.forEach(ThisElement =>
        {
            ThisElement.style.display = "none";
        });

        RemoveClassAfrerStepSection.forEach(ThisElement =>
        {
            ThisElement.classList.remove("loading_grey");
        });
    })

}

// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! TUKAR POIN !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

var OnSelectedRewards = "";

function InstantiateTukarPointMenu(thisuserinfo, mainsession, basicinfo, loggedin)
{
    OnSelectedRewards = "";

    let BasicBlackBlocker = document.createElement("div");
    BasicBlackBlocker.className = "BasicBlackBlocker";
    document.getElementsByTagName("body")[0].append(BasicBlackBlocker);

    let FlexFullDisplayPanel = document.createElement("div");
    FlexFullDisplayPanel.className = "FlexFullDisplayPanel";
    FlexFullDisplayPanel.id = "AllCropContentWrapperContainer";
    FlexFullDisplayPanel.style.padding = "0";
    FlexFullDisplayPanel.style.overflowY = "visible";
    FlexFullDisplayPanel.style.maxHeight = "none";
    BasicBlackBlocker.appendChild(FlexFullDisplayPanel);

    let TukarPointContainer = document.createElement("div");
    TukarPointContainer.className = "FlexContainerBaseAnimate TukarPointContainer";
    FlexFullDisplayPanel.appendChild(TukarPointContainer);

    // HEADER =======================================================
    let HeaderContainer = document.createElement("div");
    HeaderContainer.className = "TopBottomHeaderButtonPaddingContainer BasicBoxShadow";
    TukarPointContainer.appendChild(HeaderContainer);

    let HeaderInner = document.createElement("div");
    HeaderInner.style.flex = "1";
    HeaderInner.style.height = "fit-content";
    HeaderInner.style.display = "flex";
    HeaderInner.style.position = "relative";
    HeaderContainer.appendChild(HeaderInner);

    let HeaderTitle = document.createElement("p");
    HeaderTitle.className = "PaymentPriceFinalToPay MarginTextUpDown InterBoldTextFont";
    HeaderTitle.style.margin = "auto";
    HeaderTitle.innerHTML = window["TukarPoinTxt" + window.CurrentCountryID];
    HeaderInner.appendChild(HeaderTitle);

    let CloseBtn = document.createElement("img");
    CloseBtn.src = "/Assets/images/ButtonIcon/cancel-x-grey.svg";
    CloseBtn.className = "CloseButtonInsidePanel Selectable2";
    CloseBtn.style.position = "absolute";
    CloseBtn.style.right = "0";
    CloseBtn.style.top = "50%";
    CloseBtn.style.transform = "translateY(-50%)";
    CloseBtn.onclick = function()
    {
        window.ClosePanelAnimate(FlexFullDisplayPanel, BasicBlackBlocker, ()=>window.LoadAllRefData(mainsession, basicinfo, loggedin));
    }
    HeaderInner.appendChild(CloseBtn);

    // BLUE INFO SECTION ===================================================

    var AllMainTukarSectionFlex = document.createElement("div");
    AllMainTukarSectionFlex.className = "FlexContainerBaseAnimate";
    AllMainTukarSectionFlex.style.width = "100%";
    TukarPointContainer.appendChild(AllMainTukarSectionFlex);

    let BlueHeader = document.createElement("div");
    BlueHeader.className = "TopBottomHeaderButtonPaddingContainer";
    BlueHeader.style.backgroundColor = "#2494D9";
    AllMainTukarSectionFlex.appendChild(BlueHeader);

    let LeftInfoWrapper = document.createElement("div");
    LeftInfoWrapper.className = "LeftSectionAllPoinInfoWrapper";
    BlueHeader.appendChild(LeftInfoWrapper);

    let InputFieldMargin5 = document.createElement("div");
    InputFieldMargin5.className = "InputFieldMargin5";
    LeftInfoWrapper.appendChild(InputFieldMargin5);

    let FlexRow = document.createElement("div");
    FlexRow.style.flex = "1";
    FlexRow.style.height = "fit-content";
    FlexRow.style.display = "flex";
    InputFieldMargin5.appendChild(FlexRow);

    let CoinText = document.createElement("p");
    CoinText.className = "PaymentSectionHeaderText2 InterBoldTextFont loading_grey";
    CoinText.style.color = "transparent";
    CoinText.style.whiteSpace = "nowrap";
    CoinText.style.width = "fit-content";
    CoinText.innerHTML = "--";
    FlexRow.appendChild(CoinText);

    let BlueMessage = document.createElement("div");
    BlueMessage.className = "BlueTopHeaderMessageRefMenuWrapper";
    FlexRow.appendChild(BlueMessage);

    let RefTitle = document.createElement("p");
    RefTitle.className = "LabelGreyHeaderText InterBoldTextFont";
    RefTitle.style.color = "#FFFFFF";
    RefTitle.innerHTML = window["ReferralPointTxt" + window.CurrentCountryID];
    BlueMessage.appendChild(RefTitle);

    let RefDesc = document.createElement("p");
    RefDesc.className = "LabelGreyHeaderSmallerText InterRegularTextFont";
    RefDesc.style.color = "#FFFFFF";
    RefDesc.innerHTML = window["PointUGotInvFriTxt" + window.CurrentCountryID];
    BlueMessage.appendChild(RefDesc);

    let InputFieldMargin4 = document.createElement("div");
    InputFieldMargin4.className = "InputFieldMargin4 BasicChildMargin2";
    LeftInfoWrapper.appendChild(InputFieldMargin4);

    let RefMemberLabel = document.createElement("p");
    RefMemberLabel.className = "LabelGreyHeaderSmallerText InterMediumTextFont";
    RefMemberLabel.style.color = "#FFFFFF";
    RefMemberLabel.innerHTML = window["MemberPointTxt" + window.CurrentCountryID] + ": ";
    InputFieldMargin4.appendChild(RefMemberLabel);

    let RefMemberValue = document.createElement("p");
    RefMemberValue.className = "LabelGreyHeaderSmallerText InterMediumTextFont loading_grey";
    RefMemberValue.style.color = "transparent";
    RefMemberValue.innerHTML = "--";
    InputFieldMargin4.appendChild(RefMemberValue);

    let InputFieldMargin2 = document.createElement("div");
    InputFieldMargin2.className = "InputFieldMargin2 BasicChildMargin2";
    InputFieldMargin2.style.marginBottom = "0";
    LeftInfoWrapper.appendChild(InputFieldMargin2);

    let RefPingLabel = document.createElement("p");
    RefPingLabel.className = "LabelGreyHeaderSmallerText InterMediumTextFont";
    RefPingLabel.style.color = "#FFFFFF";
    RefPingLabel.innerHTML = window["PingPointTxt" + window.CurrentCountryID] + ": ";
    InputFieldMargin2.appendChild(RefPingLabel);

    let RefPingValue = document.createElement("p");
    RefPingValue.className = "LabelGreyHeaderSmallerText InterMediumTextFont loading_grey";
    RefPingValue.style.color = "transparent";
    RefPingValue.innerHTML = "--";
    InputFieldMargin2.appendChild(RefPingValue);

    let ContainerForBothSelectionAndFinal = document.createElement("div");
    ContainerForBothSelectionAndFinal.className = "FlexContainerBaseAnimate";
    ContainerForBothSelectionAndFinal.style.width = "100%";
    AllMainTukarSectionFlex.append(ContainerForBothSelectionAndFinal);

    // VOUCHER CHOICE SECTION ====================================================

    let VoucherSection = document.createElement("div");
    VoucherSection.className = "TopBottomHeaderButtonPaddingContainer";
    VoucherSection.style.flexDirection = "column";
    ContainerForBothSelectionAndFinal.appendChild(VoucherSection);

    let VoucherTitle = document.createElement("p");
    VoucherTitle.className = "LabelGreyHeaderText InterBoldTextFont";
    VoucherTitle.style.color = "#232933";
    VoucherTitle.innerHTML = window["PilihRewardsTxt" + window.CurrentCountryID] + ' 🎟️<span style="color:#C10000;">*</span>';
    VoucherSection.appendChild(VoucherTitle);

    let VoucherSubtitle = document.createElement("p");
    VoucherSubtitle.className = "LabelGreyHeaderSmallerText InterRegularTextFont";
    VoucherSubtitle.style.color = "#101828";
    VoucherSubtitle.innerHTML = window["TukarPoinDgnRewardFavTxt" + window.CurrentCountryID];
    VoucherSection.appendChild(VoucherSubtitle);

    // No Voucher Exist ---------------------------------------------
    
    let NoVoucherContainer = document.createElement("div");
    NoVoucherContainer.className = "NoFeaturedPropertyFoundContainer";
    NoVoucherContainer.id = "NoVoucherContainerTukarPoint";
    NoVoucherContainer.style.display = "none";
    VoucherSection.appendChild(NoVoucherContainer);
    
    let NoVoucherIcon = document.createElement("img");
    NoVoucherIcon.className = "NoFoundIcon2";
    NoVoucherIcon.src = "/Assets/images/Icon/GiftGrey.svg";
    NoVoucherContainer.appendChild(NoVoucherIcon);

    let NoFoundHeaderText = document.createElement("p");
    NoFoundHeaderText.className = "NoFoundHeaderText InterBoldTextFont";
    NoFoundHeaderText.innerHTML = window["BlmAdaRewardsTxt" + window.CurrentCountryID];
    NoVoucherContainer.appendChild(NoFoundHeaderText);
    
    let NoFoundMessageText = document.createElement("p");
    NoFoundMessageText.className = "NoFoundMessageText InterRegularTextFont";
    NoFoundMessageText.style.width = "85%";
    NoFoundMessageText.innerHTML = window["BlmAdaRewardsMsgTxt" + window.CurrentCountryID];
    NoVoucherContainer.appendChild(NoFoundMessageText);

    // Instantiate Voucher ======================================

    let VoucherMainContainer = document.createElement("div");
    VoucherMainContainer.className = "VoucherMainContainerRefMenu HideScrollBar BasicGradientTopBottomMask";
    VoucherSection.appendChild(VoucherMainContainer);

    // Instantiate Loading -------------------------------

    for(let i = 0; i < 6; i++)
    {
        InstantiateLoadingReward(VoucherMainContainer);
    }

    // ARE YOU SURE SELECT SECTION ====================================================

    let ConfirmContainer = document.createElement("div");
    ConfirmContainer.className = "TopBottomHeaderButtonPaddingContainer InputFieldMargin2";
    ConfirmContainer.style.flexDirection = "column";
    ConfirmContainer.style.display = "none";
    ContainerForBothSelectionAndFinal.appendChild(ConfirmContainer);

    let TextWrapper = document.createElement("div");
    TextWrapper.className = "InputFieldMargin2";
    ConfirmContainer.appendChild(TextWrapper);
    
    let ConfirmText = document.createElement("p");
    ConfirmText.className = "LabelGreyHeaderText InterRegularTextFont";
    ConfirmText.style.color = "#101828";
    ConfirmText.style.marginLeft = "auto";
    ConfirmText.style.marginRight = "auto";
    ConfirmText.innerHTML = `Kamu yakin ingin menukar <span class="InterBoldTextFont">1 Ping Point</span> dengan Voucher ini?`;
    TextWrapper.appendChild(ConfirmText);

    let HereToInstantiateClone = document.createElement("div");
    HereToInstantiateClone.style.width = "fit-content";
    HereToInstantiateClone.style.height = "fit-content";
    HereToInstantiateClone.style.display = "flex";
    HereToInstantiateClone.style.margin = "0 auto";
    ConfirmContainer.appendChild(HereToInstantiateClone);

    // BOTTOM SECTION ====================================================

    let Footer = document.createElement("div");
    Footer.className = "TopBottomHeaderButtonPaddingContainer BasicBoxShadowUp";
    Footer.style.position = "relative";
    Footer.style.marginBottom = "0";
    AllMainTukarSectionFlex.appendChild(Footer);

    let ButtonWrapper = document.createElement("div");
    ButtonWrapper.className = "MoreThanOneButtonFlexWrapper InputFieldMarginBoth";
    ButtonWrapper.style.height = "fit-content";
    ButtonWrapper.style.margin = "auto";
    ButtonWrapper.style.marginRight = "0";
    Footer.appendChild(ButtonWrapper);

    let CancelBtn = document.createElement("button");
    CancelBtn.className = "BasicTextButton BasicBoxShadow BlueButtonLight PaddingExtendedButton2 Selectable";
    CancelBtn.style.backgroundColor = "transparent";
    CancelBtn.style.color = "#C10000";
    CancelBtn.innerHTML = window["CancelTxt" + window.CurrentCountryID];
    ButtonWrapper.appendChild(CancelBtn);

    let ContinueBtn = document.createElement("button");
    ContinueBtn.className = "BasicTextButton BasicBoxShadow OrangeButton PaddingExtendedButton2 ButtonUnselectable";
    ContinueBtn.innerHTML = window["ContinueTxt2" + window.CurrentCountryID];
    ButtonWrapper.appendChild(ContinueBtn);


    // FINAL AFTER REQUEST ======================================================

    let WaitingRequestFlexWrapper = document.createElement("div");
    WaitingRequestFlexWrapper.className = "FlexContainerBaseAnimate";
    WaitingRequestFlexWrapper.style.width = "100%";
    WaitingRequestFlexWrapper.style.display = "none";
    TukarPointContainer.append(WaitingRequestFlexWrapper);

    let WaitingRequestContainer = document.createElement("div");
    WaitingRequestContainer.className = "NoFeaturedPropertyFoundContainer";
    WaitingRequestContainer.id = "NoVoucherContainerTukarPoint";
    WaitingRequestFlexWrapper.append(WaitingRequestContainer);
    
    let WaitingClockIcon = document.createElement("img");
    WaitingClockIcon.className = "NoFoundIcon2 InputFieldMargin2";
    WaitingClockIcon.src = "/Assets/images/Icon/hourglass-verify.svg";
    WaitingRequestContainer.append(WaitingClockIcon);

    let WaitingRequestHeaderText = document.createElement("p");
    WaitingRequestHeaderText.className = "NoFoundHeaderText InterBoldTextFont";
    WaitingRequestHeaderText.innerHTML = window["WaitRewardsExchangeHeaderTxt" + window.CurrentCountryID];
    WaitingRequestHeaderText.style.maxWidth = "85%";
    WaitingRequestContainer.append(WaitingRequestHeaderText);
    
    let WaitingRequestMessageText = document.createElement("p");
    WaitingRequestMessageText.className = "NoFoundMessageText InterRegularTextFont InputFieldMargin2";
    WaitingRequestMessageText.style.width = "85%";
    WaitingRequestMessageText.innerHTML = window["WaitRewardsExchangeTxt" + window.CurrentCountryID];
    WaitingRequestContainer.append(WaitingRequestMessageText);


    let SelesaiButton = document.createElement("button");
    SelesaiButton.className = "BasicTextButton BasicBoxShadow OrangeButton SignInButtonTop Selectable";
    SelesaiButton.style = "margin: 0 auto;";
    SelesaiButton.onclick = function()
    {
        window.ClosePanelAnimate(FlexFullDisplayPanel, BasicBlackBlocker, ()=>window.LoadAllRefData(mainsession, basicinfo, loggedin));
    }
    WaitingRequestContainer.append(SelesaiButton);

    let SelesaiButtonWrapper = document.createElement("div");
    SelesaiButtonWrapper.style = "width: fit-content; height: fit-content; display: flex; margin: auto;";
    SelesaiButton.append(SelesaiButtonWrapper);

    let SelesaiButtonIcon = document.createElement("img");
    SelesaiButtonIcon.className = "BasicIconInsideButton2";
    SelesaiButtonIcon.src = "/Assets/images/ButtonIcon/check-circle-white.svg";
    SelesaiButtonIcon.style.marginLeft = 0;
    SelesaiButtonWrapper.append(SelesaiButtonIcon);

    let SelesaiButtonText = document.createElement("p");
    SelesaiButtonText.innerHTML = window["SelesaiTxt" + window.CurrentCountryID];
    SelesaiButtonWrapper.append(SelesaiButtonText);

    // LOAD REWARDS OR VOUCHER TO INSTANTIATE -------------------------------

    let URLLoadVoucherList = "/v2/rewards?id_user=" + thisuserinfo.id_user;
    //console.log(URLLoadVoucherList);

    window.CallApiAxios({
        method: "GET",
        url: URLLoadVoucherList,
    }).then(res =>
    {
        //console.log(res);
        let VoucherListData = res.data.data;
        InstantiateSelectableReward(VoucherListData, CoinText, RefMemberValue, RefPingValue, VoucherMainContainer, NoVoucherContainer, ContinueBtn, ConfirmText, HereToInstantiateClone);
    })
    .catch(err =>
    {
        //console.error(err);
    });

    
    // Add Onclick Function to Button -----------------------------------
    
    CancelBtn.onclick = function()
    {
        if(ConfirmContainer.style.display == "none")
        {
            window.ClosePanelAnimate(FlexFullDisplayPanel, BasicBlackBlocker, ()=>window.LoadAllRefData(mainsession, basicinfo, loggedin));
        }
        else
        {
            window.MovePanelInsideContainerBack(ConfirmContainer, VoucherSection, ContainerForBothSelectionAndFinal);
            CancelBtn.innerHTML = window["CancelTxt" + window.CurrentCountryID];
            ContinueBtn.innerHTML = window["ContinueTxt2" + window.CurrentCountryID];
            ContinueBtn.className = "BasicTextButton BasicBoxShadow OrangeButton PaddingExtendedButton2 Selectable";
        }

    }

    ContinueBtn.onclick = function()
    {
        if(OnSelectedRewards.innerHTML == "")
            return

        if(ConfirmContainer.style.display == "none")
        {
            let ConfirmVoucherBlocker = window.InstantiateLoadingBlocker("ConfirmVoucherBlocker");

            window.MovePanelInsideContainerNext(VoucherSection, ConfirmContainer, ContainerForBothSelectionAndFinal, function(){ConfirmVoucherBlocker.remove()});
            CancelBtn.innerHTML = window["BackTxt" + window.CurrentCountryID];
            ContinueBtn.innerHTML = window["TukarRewardTxt" + window.CurrentCountryID];
            ContinueBtn.className = "BasicTextButton BasicBoxShadow OrangeButton SignInButtonTop Selectable";
        }
        else
        {
            let LoadinRequestRewardsBlocker = window.InstantiateLoadingBlocker("LoadinRequestRewardsBlocker");

            RequestRewardsGET(thisuserinfo.id_user, LoadinRequestRewardsBlocker, ()=>window.MovePanelInsideContainerNext(AllMainTukarSectionFlex, WaitingRequestFlexWrapper, TukarPointContainer, function(){LoadinRequestRewardsBlocker.remove()})); 
        }
    }

    window.OpenPanelAnimate(FlexFullDisplayPanel, BasicBlackBlocker);
}

function InstantiateLoadingReward(wheretoinstantiate)
{
    let VoucherWrapperRefMenu = document.createElement("div");
    VoucherWrapperRefMenu.className = "VoucherWrapperRefMenu";
    VoucherWrapperRefMenu.style.pointerEvents = "none";
    wheretoinstantiate.append(VoucherWrapperRefMenu);

    let LabelContainer = document.createElement("label");
    LabelContainer.className = "FilterCheckBoxContainer CircleCheckBoxContainer";
    VoucherWrapperRefMenu.append(LabelContainer);

    let InputCheckBox = document.createElement("input");
    InputCheckBox.className = "FilterCheckBox Selectable";
    InputCheckBox.type = "checkbox";
    InputCheckBox.style.pointerEvents = "none";
    LabelContainer.append(InputCheckBox);

    let CheckBoxSpan = document.createElement("span");
    CheckBoxSpan.className = "CheckBoxSpan";
    LabelContainer.append(CheckBoxSpan);

    // Main Section --------------------------------------------------

    let VoucherMainPanel = document.createElement("div");
    VoucherMainPanel.className = "VoucherMainPanel BasicBoxShadow BasicRoundRadius";
    VoucherWrapperRefMenu.append(VoucherMainPanel);

    // Image --------
    let VoucherImageContainer = document.createElement("div");
    VoucherImageContainer.className = "VoucherImageContainer loading_grey";
    VoucherMainPanel.append(VoucherImageContainer);

    let VoucherInfoWrapper = document.createElement("div");
    VoucherInfoWrapper.className = "VoucherInfoWrapper";
    VoucherMainPanel.append(VoucherInfoWrapper);

    // Title --------
    let TitleRow = document.createElement("div");
    TitleRow.className = "BasicChildMargin2 InputFieldMargin3";
    TitleRow.style.display = "flex";
    TitleRow.style.width = "100%";
    TitleRow.style.marginBottom = "0";
    VoucherInfoWrapper.append(TitleRow);

    let TitleSkeleton = document.createElement("div");
    TitleSkeleton.className = "RoomHotelRightInfo2 loading_grey PriceGreyLoading";
    TitleSkeleton.style.marginLeft = "0";
    TitleSkeleton.style.width = "80%";
    TitleRow.append(TitleSkeleton);

    // Description --------
    let Row1 = document.createElement("div");
    Row1.className = "PoinWithIconWrapper BasicChildMargin2 InputFieldMargin4";
    Row1.style.width = "100%";
    Row1.style.marginBottom = "0";
    VoucherInfoWrapper.append(Row1);

    let Row1Left = document.createElement("div");
    Row1Left.className = "RoomSmallInfo loading_grey";
    Row1Left.style.margin = "0";
    Row1Left.style.width = "50%";
    Row1.append(Row1Left);

    let Row1Right = document.createElement("div");
    Row1Right.className = "RoomSmallInfo loading_grey";
    Row1Right.style.marginLeft = "auto";
    Row1Right.style.width = "30%";
    Row1.append(Row1Right);

    let Row2 = document.createElement("div");
    Row2.className = "PoinWithIconWrapper BasicChildMargin2 InputFieldMargin4";
    Row2.style.width = "100%";
    Row2.style.marginBottom = "0";
    VoucherInfoWrapper.appendChild(Row2);

    let Row2Left = document.createElement("div");
    Row2Left.className = "RoomSmallInfo loading_grey";
    Row2Left.style.margin = "0";
    Row2Left.style.width = "40%";
    Row2.appendChild(Row2Left);

    let Row2Right = document.createElement("div");
    Row2Right.className = "RoomSmallInfo loading_grey";
    Row2Right.style.marginLeft = "auto";
    Row2Right.style.width = "40%";
    Row2.appendChild(Row2Right);

    return VoucherWrapperRefMenu;
}

function InstantiateSelectableReward(VoucherListData, CoinText, RefMemberValue, RefPingValue, VoucherMainContainer, NoVoucherContainer, ContinueBtn, ConfirmText, HereToInstantiateClone)
{
    //console.log(VoucherListData);

    // Set User Info Top --------------------------------

    let UserInfoListData = VoucherListData.member_ping;
    let TotalPointNow = UserInfoListData.ref_ping_counts_now + UserInfoListData.ref_member_counts_now;
    CoinText.innerHTML = TotalPointNow +'<img src="/Assets/images/ButtonIcon/coin-icon.svg">';
    CoinText.style.color = "white";
    CoinText.className = "PaymentSectionHeaderText2 InterBoldTextFont";

    RefMemberValue.innerHTML = UserInfoListData.ref_member_counts_now;
    RefMemberValue.className = "LabelGreyHeaderSmallerText InterMediumTextFont";
    RefMemberValue.style.color = "#FFDE67";

    RefPingValue.innerHTML = UserInfoListData.ref_ping_counts_now;
    RefPingValue.className = "LabelGreyHeaderSmallerText InterMediumTextFont";
    RefPingValue.style.color = "#FFDE67";

    // Instantiate Reward List --------------------------

    let RewardListData = VoucherListData.reward_data;

    VoucherMainContainer.innerHTML = "";

    if (RewardListData.length > 0)
    {
        NoVoucherContainer.style.display = "none";
        VoucherMainContainer.style.display = "";

        for (let i = 0; i < RewardListData.length; i++)
        {
            let LoadingRefmenuContainer = InstantiateLoadingReward(VoucherMainContainer);

            let VoucherWrapper = document.createElement("div");
            VoucherWrapper.className = "VoucherWrapperRefMenu Selectable2";
            VoucherWrapper.style.display = "none";
            VoucherMainContainer.appendChild(VoucherWrapper);

            let VoucherLabel = document.createElement("label"); // Check Box -----------------
            VoucherLabel.className = "FilterCheckBoxContainer CircleCheckBoxContainer";
            VoucherWrapper.appendChild(VoucherLabel);

            let VoucherCheckbox = document.createElement("input");
            VoucherCheckbox.type = "radio";
            VoucherCheckbox.className = "FilterCheckBox Selectable";
            VoucherCheckbox.name = "voucher-to-exchange";
            VoucherLabel.appendChild(VoucherCheckbox);

            let VoucherSpan = document.createElement("span");
            VoucherSpan.className = "CheckBoxSpan";
            VoucherLabel.appendChild(VoucherSpan);

            let VoucherPanel = document.createElement("div");
            VoucherPanel.className = "VoucherMainPanel BasicBoxShadow BasicRoundRadius";
            VoucherWrapper.appendChild(VoucherPanel);

            let VoucherImageContainer = document.createElement("div"); // Image -----------------
            VoucherImageContainer.className = "VoucherImageContainer";
            VoucherPanel.appendChild(VoucherImageContainer);

            let VoucherStock = document.createElement("p");
            VoucherStock.className = "SmallRoundedText InterMediumTextFont VoucherStatus" + RewardListData[i].status_reward;
            VoucherStock.innerHTML = RewardListData[i].status_reward;
            VoucherImageContainer.appendChild(VoucherStock);

            let VoucherImage = document.createElement("img");
            VoucherImage.src = RewardListData[i].reward_image;
            VoucherImage.className = "ImageFullCover";
            VoucherImageContainer.appendChild(VoucherImage);

            let VoucherInfoWrapper = document.createElement("div"); // Voucher Name + Status -----------------
            VoucherInfoWrapper.className = "VoucherInfoWrapper";
            VoucherPanel.appendChild(VoucherInfoWrapper);

            let VoucherRow1 = document.createElement("div");
            VoucherRow1.className = "BasicChildMargin2 InputFieldMargin3";
            VoucherRow1.style.display = "flex";
            VoucherRow1.style.width = "100%";
            VoucherInfoWrapper.appendChild(VoucherRow1);

            let VoucherName = document.createElement("p");
            VoucherName.className = "LabelGreyHeaderSmallerText2 InterBoldTextFont";
            VoucherName.innerHTML = RewardListData[i].reward_name;
            VoucherRow1.appendChild(VoucherName);

            if (RewardListData[i].left <= LimitLeftShowVoucherTrade && RewardListData[i].left != null) {
                let VoucherStockSmall = document.createElement("p");
                VoucherStockSmall.className = "RedButton SmallRoundedText InterRegularTextFont";
                VoucherStockSmall.style.marginLeft = "auto";
                VoucherStockSmall.innerHTML = window["HowManyLeftTxt" + window.CurrentCountryID](RewardListData[i].left);
                VoucherRow1.appendChild(VoucherStockSmall);
            }

            let VoucherRow5 = document.createElement("div"); // Limit Penukaran -----------------
            VoucherRow5.className = "PoinWithIconWrapper BasicChildMargin2 InputFieldMargin4";
            VoucherRow5.style.width = "100%";
            VoucherInfoWrapper.appendChild(VoucherRow5);

            let ExpiryDateIcon = document.createElement("img");
            ExpiryDateIcon.src = "/Assets/images/ButtonIcon/clock-icon-orange.svg";
            ExpiryDateIcon.style.marginLeft = "0";
            VoucherRow5.appendChild(ExpiryDateIcon);

            let ExpiryDateText = document.createElement("p");
            ExpiryDateText.className = "SmallerRoomDescriptionText InterRegularTextFont";
            ExpiryDateText.style.color = "#797979";
            ExpiryDateText.innerHTML = window["BerlakuSDTxt" + window.CurrentCountryID];
            VoucherRow5.appendChild(ExpiryDateText);

            let ExpiryDateValue = document.createElement("p");
            ExpiryDateValue.className = "SmallerRoomDescriptionText InterRegularTextFont";
            ExpiryDateValue.style.marginLeft = "auto";
            ExpiryDateValue.innerHTML = window["NoExpDateTxt" + window.CurrentCountryID];
            VoucherRow5.appendChild(ExpiryDateValue);

            if (RewardListData[i].valid_until != null && RewardListData[i].valid_until != "")
            {
                let ThisVoucherDeadlineArray = RewardListData[i].valid_until.split("-");
                let VoucherEndYear = ThisVoucherDeadlineArray[0];
                let VoucherEndMonth = ThisVoucherDeadlineArray[1];
                let VoucherEndDate = ThisVoucherDeadlineArray[2];

                ExpiryDateValue.innerHTML = VoucherEndDate + " " + window["monthNamesFull" + window.CurrentCountryID][parseInt(VoucherEndMonth) - 1] + " " + VoucherEndYear;
            }

            let VoucherRow2 = document.createElement("div"); // Minimum Transaction -----------------
            VoucherRow2.className = "PoinWithIconWrapper BasicChildMargin2 InputFieldMargin4";
            VoucherRow2.style.width = "100%";
            VoucherInfoWrapper.appendChild(VoucherRow2);

            let RpIcon = document.createElement("img");
            RpIcon.src = "/Assets/images/ButtonIcon/RP-icon.svg";
            RpIcon.style.marginLeft = "0";
            VoucherRow2.appendChild(RpIcon);

            let MinText = document.createElement("p");
            MinText.className = "SmallerRoomDescriptionText InterRegularTextFont";
            MinText.style.color = "#797979";
            MinText.innerHTML = window["MinTransactTxt" + window.CurrentCountryID];
            VoucherRow2.appendChild(MinText);

            let MinValue = document.createElement("p");
            MinValue.className = "SmallerRoomDescriptionText InterRegularTextFont";
            MinValue.style.marginLeft = "auto";
            MinValue.innerHTML = window["NoMinimumTxt" + window.CurrentCountryID];
            VoucherRow2.appendChild(MinValue);

            let VoucherRow3 = document.createElement("div"); // Poin Dibutuhkan -----------------
            VoucherRow3.className = "PoinWithIconWrapper BasicChildMargin2 InputFieldMargin4";
            VoucherRow3.style.width = "100%";
            VoucherInfoWrapper.appendChild(VoucherRow3);

            let CoinIcon = document.createElement("img");
            CoinIcon.src = "/Assets/images/ButtonIcon/coin-icon.svg";
            CoinIcon.style.marginLeft = "0";
            VoucherRow3.appendChild(CoinIcon);

            let PoinText = document.createElement("p");
            PoinText.className = "SmallerRoomDescriptionText InterRegularTextFont";
            PoinText.style.color = "#797979";
            PoinText.innerHTML = window["PoinDibutuhkanTxt" + window.CurrentCountryID];
            VoucherRow3.appendChild(PoinText);

            let PoinValue = document.createElement("p");
            PoinValue.className = "SmallerRoomDescriptionText InterRegularTextFont";
            PoinValue.style.marginLeft = "auto";
            PoinValue.innerHTML = window.DetermineWhichPoinNameWithValue(RewardListData[i].point_need, RewardListData[i].point_types);
            VoucherRow3.appendChild(PoinValue);

            let VoucherRow4 = document.createElement("div"); // Limit Penukaran -----------------
            VoucherRow4.className = "PoinWithIconWrapper BasicChildMargin2";
            VoucherRow4.style.width = "100%";
            VoucherInfoWrapper.appendChild(VoucherRow4);

            let LimitIcon = document.createElement("img");
            LimitIcon.src = "/Assets/images/ButtonIcon/discount-voucher-icon.svg";
            LimitIcon.style.marginLeft = "0";
            VoucherRow4.appendChild(LimitIcon);

            let LimitText = document.createElement("p");
            LimitText.className = "SmallerRoomDescriptionText InterRegularTextFont";
            LimitText.style.color = "#797979";
            LimitText.innerHTML = window["BatasPenukaranPerUserTxt" + window.CurrentCountryID];
            VoucherRow4.appendChild(LimitText);

            let LimitValue = document.createElement("p");
            LimitValue.className = "SmallerRoomDescriptionText InterRegularTextFont";
            LimitValue.style.marginLeft = "auto";
            LimitValue.innerHTML = window["TidakadaLimitTxt" + window.CurrentCountryID];
            VoucherRow4.appendChild(LimitValue);

            if (RewardListData[i].limit_per_user != null)
            {
                LimitValue.innerHTML = RewardListData[i].limit_per_user + "x " + window["JumlahKaliPenukaranTxt" + window.CurrentCountryID];
            }

            // Set Function ---------------------------------------

            VoucherCheckbox.onchange = function ()
            {
                window.event.preventDefault();
                window.event.stopPropagation();

                OnSelectedRewards = RewardListData[i].id_reward;

                ContinueBtn.className = "BasicTextButton BasicBoxShadow OrangeButton PaddingExtendedButton2 Selectable";
                ConfirmText.innerHTML = window["KamuYakinInginMenukarTxt" + window.CurrentCountryID](window.DetermineWhichPoinNameWithValue(RewardListData[i].point_need, RewardListData[i].point_types));

                let CloneRewards = VoucherPanel.cloneNode(true);
                CloneRewards.className = "VoucherNonInsidePanel BasicBoxShadow BasicRoundRadius";
                HereToInstantiateClone.innerHTML = "";
                HereToInstantiateClone.append(CloneRewards);
            };

            VoucherWrapper.onclick = function (event)
            {
                window.event.preventDefault();
                window.event.stopPropagation();

                VoucherCheckbox.checked = true;
                VoucherCheckbox.onchange();
                // //console.log(VoucherCheckbox.checked);
            };

            window.HandleAllImageLoadWithFunction(VoucherWrapper.querySelectorAll("img"), function ()
            {
                LoadingRefmenuContainer.remove();
                VoucherWrapper.style.display = "";
            });
        }
    } 
    else
    {
        NoVoucherContainer.style.display = "";
        VoucherMainContainer.style.display = "none";
    }

}



// ========================================= REQUEST VOUCHER ==============================================

function RequestRewardsGET(iduser, LoadinRequestRewardsBlocker, functiontocall)
{
    let RequestRewardsURL = "/v2/rewards/" + OnSelectedRewards + "/redeem";

    let formData = new FormData();
    formData.append('id_user', iduser);
    formData.append('lang', window.CurrentCountryID);

    //console.log(RequestRewardsURL);
    //console.log(window.ConvertFormDataToJSON(formData));

    window.CallApiAxios({
        method: "POST",
        url: RequestRewardsURL,
        data: formData
    }).then(res =>
    {
        //console.log(res);
        functiontocall();
    })
    .catch(err =>
    {
        //console.error(err);
        window.DisplayWarningPopUp("WarningPanelFailed WarningFailedAlert", window["ErrorWhenRequestRewardsTxt" + window.CurrentCountryID]);
        LoadinRequestRewardsBlocker.remove();
    });
}

// =========================== VIEW ALL HISTORY ============================

function OpenViewAllHistoryPanel(RewardHistoryDataUser, mainsession, basicinfo, loggedin)
{
    //console.log("mainsession", mainsession);
    //console.log("basicinfo", basicinfo);
    //console.log("loggedin", loggedin);

    let BasicBlackBlocker = document.createElement("div");
    BasicBlackBlocker.className = "BasicBlackBlocker";
    document.getElementsByTagName("body")[0].append(BasicBlackBlocker);

    let FlexFullDisplayPanel = document.createElement("div");
    FlexFullDisplayPanel.className = "FlexFullDisplayPanel";
    FlexFullDisplayPanel.style.padding = "0";
    FlexFullDisplayPanel.style.overflowY = "visible";
    FlexFullDisplayPanel.style.maxHeight = "none";
    BasicBlackBlocker.append(FlexFullDisplayPanel);

    let MainContainerPanel = document.createElement("div");
    MainContainerPanel.className = "FlexContainerBaseAnimate TukarPointContainer";
    FlexFullDisplayPanel.append(MainContainerPanel);

    // Header ---------
    let HeaderContainer = document.createElement("div");
    HeaderContainer.className = "TopBottomHeaderButtonPaddingContainer BasicBoxShadow";
    MainContainerPanel.append(HeaderContainer);

    let HeaderInner = document.createElement("div");
    HeaderInner.style.flex = "1";
    HeaderInner.style.height = "fit-content";
    HeaderInner.style.display = "flex";
    HeaderInner.style.position = "relative";
    HeaderContainer.append(HeaderInner);

    let HeaderTitle = document.createElement("p");
    HeaderTitle.className = "PaymentPriceFinalToPay MarginTextUpDown InterBoldTextFont";
    HeaderTitle.style.margin = "auto";
    HeaderTitle.innerHTML = window["HistoryPointTxt" + window.CurrentCountryID];
    HeaderInner.append(HeaderTitle);

    let CloseButton = document.createElement("img");
    CloseButton.src = "/Assets/images/ButtonIcon/cancel-x-grey.svg";
    CloseButton.className = "CloseButtonInsidePanel Selectable2";
    CloseButton.style.position = "absolute";
    CloseButton.style.right = "0";
    CloseButton.style.top = "50%";
    CloseButton.style.transform = "translateY(-50%)";
    CloseButton.onclick = function()
    {
        window.ClosePanelAnimate(FlexFullDisplayPanel, BasicBlackBlocker, window.LoadAllRefData(mainsession, basicinfo, loggedin));
    }
    HeaderInner.append(CloseButton);

    // History Container ============================================

    let HIstoryParentContainer = document.createElement("div");
    HIstoryParentContainer.className = "FlexFullDisplayPanel";
    HIstoryParentContainer.style.width = "100%";
    HIstoryParentContainer.style.zIndex = "0";
    HIstoryParentContainer.style.boxSizing = "border-box";
    MainContainerPanel.append(HIstoryParentContainer);

    let WhereToInstantiateHistory = document.createElement("div");
    WhereToInstantiateHistory.className = "PriceTextMainContainer";
    HIstoryParentContainer.append(WhereToInstantiateHistory);

    InstantiateHistoryPanel(RewardHistoryDataUser, WhereToInstantiateHistory, "#F9FAFB");
    
    window.OpenPanelAnimate(FlexFullDisplayPanel, BasicBlackBlocker);
}


// ================================== CHANGE REFERRAL ==================================

window.ChangeRefMenuSection = function(thistypename, mainsession, loggedin)
{
    SetLoadingRightSection();

    let TopButtons = document.querySelectorAll('.TopReferralSectionButton');
    let OrangeBackAnimate = document.getElementById("SelectedSortOrangeWrapper");

    CurrentRefSection = thistypename;

    for(let i = 0; i < TopButtons.length; i++)
    {
        if((thistypename + "SectionButton") == TopButtons[i].id)
        {
            TopButtons[i].className = "TopReferralSectionButton TopReferralSectionSelected Selectable2";
            OrangeBackAnimate.style.left = (50 * i )+"%";
        }
        else
        {
            TopButtons[i].className = "TopReferralSectionButton Selectable2";
        }
    }

    if(CurrentRefSection == "AjakTemen")
    {
        RefMenuHeaderText.innerHTML = window["TemenPinginGoTxt" + window.CurrentCountryID];
        RefMenuMessageText.innerHTML = window["TemenYangBerhasilTxt" + window.CurrentCountryID];
    }
    else
    {
        RefMenuHeaderText.innerHTML = window["PingBerhasilTxt" + window.CurrentCountryID];
        RefMenuMessageText.innerHTML = window["NumberPingCompletedBasedOnInvTxt" + window.CurrentCountryID];
    }
    ChangeDisplayBasedOnCurrentRefSection(mainsession, loggedin);
}

function ChangeDisplayBasedOnCurrentRefSection(mainsession, loggedin)
{
    BelumAdaYangMenginapHeaderText.innerHTML = window[CurrentRefSection + "NoBookingOrPingReferralHeaderTxt" + window.CurrentCountryID];
    BelumAdaYangMenginapMessageText.innerHTML = window[CurrentRefSection + "NoBookingOrPingReferralMessageTxt" + window.CurrentCountryID];

    CaraMudahNginepGratisText.innerHTML = window[CurrentRefSection + "MainHeaderTxt" + window.CurrentCountryID];

    ReferralStep1Header.innerHTML = window[CurrentRefSection + "Step1HeaderTxt" + window.CurrentCountryID];
    ReferralStep1Message.innerHTML = window[CurrentRefSection + "Step1MessageTxt" + window.CurrentCountryID];

    ReferralStep2Header.innerHTML = window[CurrentRefSection + "Step2HeaderTxt" + window.CurrentCountryID];
    ReferralStep2Message.innerHTML = window[CurrentRefSection + "Step2MessageTxt" + window.CurrentCountryID];

    ReferralStep3Header.innerHTML = window[CurrentRefSection + "Step3HeaderTxt" + window.CurrentCountryID];
    ReferralStep3Message.innerHTML = window[CurrentRefSection + "Step3MessageTxt" + window.CurrentCountryID];

    ShareReferralInputContainer.style.display = "none";
    if(CurrentRefSection == "AjakTemen")
        ShareReferralInputContainer.style.display = "";

    if(CurrentRefSection == "AjakTemen")
    {
        
    }

    LoadReferralMenuBasedOnSection(mainsession, loggedin);
}

function LoadReferralMenuBasedOnSection(mainsession)
{
    let URLToLoad = "/v2/users/" + mainsession.usd_PING_id + "/referrals/members";
    if(CurrentRefSection == "NginepGratis")
        URLToLoad = "/v2/users/" + mainsession.usd_PING_id + "/referrals/pings";

    window.CallApiAxios({
        method: "GET",
        url: URLToLoad,
    }).then(res =>
    {
        //console.log(URLToLoad);
        //console.log(res);
        
        if(res.status == 200)
        {
            let LoadedDataToSend;

            // Determine Which Data To Instantiate Based On Current Right Section -----------------------
            if(CurrentRefSection == "NginepGratis")
            {
                LoadedDataToSend = res.data.data.ref_ping_history;
            }
            else
            {
                LoadedDataToSend = res.data.data.ref_member_history;
            }

            RefMenuHowManyText.innerHTML = LoadedDataToSend.length;
            
            // If Less Than Maximum Create Dummy Until It Fills Everything --------------------
            if(HowManyMaxDisplayRef > LoadedDataToSend.length && LoadedDataToSend.length > 0)
            {
                for(let i = LoadedDataToSend.length; i < HowManyMaxDisplayRef; i++)
                {
                    LoadedDataToSend.push(null);
                }
            }

            //console.log(LoadedDataToSend);
            InstantiateAllRightElements(LoadedDataToSend);
        }
    })
    .catch(err =>
    {
        //console.error(err);
        ReffTableContainer.style.display = "none";
        BelumAdaMenginapContainer.style.display = "";
    });
}

// PREPARE ALL ELEMENT RIGHT ==================================

function InstantiateAllRightElements(ThisDataGet)
{
    let ThisDataUserData = ThisDataGet;

    if(ThisDataUserData.length == 0)
    {
        // If No Data -------------------
        ReffTableContainer.style.display = "none";
        BelumAdaMenginapContainer.style.display = "";
    }
    else
    {
        ReffTableContainer.style.display = "";
        BelumAdaMenginapContainer.style.display = "none";
        ReffTableTBody.innerHTML = "";

        // Instantiate Table --------------------------

        for (let i = 0; i < ThisDataUserData.length; i++)
        {
            if (i < HowManyMaxDisplayRef) // If it Still Less than Maximum Number ------------------------------
            {
                if(ThisDataUserData[i] != null)
                {
                    let ThisUserInfo = ThisDataUserData[i]?.user_booking || ThisDataUserData[i]?.user_new;

                    let LoadingHistoryTr = document.createElement("tr");
                    ReffTableTBody.append(LoadingHistoryTr);

                    let UserProfileTD = document.createElement("td"); // User Profile ---------------------------
                    UserProfileTD.style.width = "35%";
                    LoadingHistoryTr.append(UserProfileTD);

                    let UserProfileWrapper = document.createElement("div");
                    UserProfileWrapper.className = "ReffTableTDWrapper";
                    UserProfileTD.append(UserProfileWrapper);

                    let UserTopProfileIcon = document.createElement("div");
                    UserTopProfileIcon.className = "UserTopProfileIcon";
                    UserProfileWrapper.append(UserTopProfileIcon);

                    let UserProfileURL = ThisUserInfo.profile_picture;
                    if(UserProfileURL == null)
                        UserProfileURL = "/Assets/images/ProfilePicture.jpg";

                    let UserTopProfileIMG = document.createElement("img");
                    UserTopProfileIMG.className = "ImageFullCover";
                    window.checkImageUrlValid(UserProfileURL, "/Assets/images/ProfilePicture.jpg", UserTopProfileIMG, () => {}, { quality: 50});
                    UserTopProfileIcon.append(UserTopProfileIMG);

                    let UserNameText = document.createElement("p");
                    UserNameText.className = "LabelGreyHeaderSmallerText InterMediumTextFont";
                    UserNameText.innerHTML = ThisUserInfo.first_name;
                    if(ThisUserInfo.last_name != null && ThisUserInfo.last_name.replace(/ /g, "") != "")
                        UserNameText.innerHTML = ThisUserInfo.first_name + " " + ThisUserInfo.last_name;
                    UserProfileWrapper.append(UserNameText);

                    if(CurrentRefSection == "AjakTemen")
                    {
                        UserProfileTD.style.width = "100%";
                    }
                    else
                    {
                        let DateAndTimeArray = ThisDataUserData[i].create_at.split(" ")[0];
                        let DateArray = DateAndTimeArray.split("-");

                        let DateTD = document.createElement("td"); // Date ---------
                        DateTD.style.width = "25%";
                        LoadingHistoryTr.append(DateTD);

                        let DateWrapper = document.createElement("div");
                        DateWrapper.className = "ReffTableTDWrapper";
                        DateTD.append(DateWrapper);

                        let DateText = document.createElement("p");
                        DateText.className = "LabelGreyHeaderSmallerText InterMediumTextFont";
                        DateText.innerHTML = DateArray[2] + " " + window["monthNames" + window.CurrentCountryID][parseInt(DateArray[1])-1] + " " + DateArray[0];
                        DateWrapper.append(DateText);

                        let LocationTD = document.createElement("td"); // Location ---------
                        LocationTD.style.width = "40%";
                        LoadingHistoryTr.append(LocationTD);

                        let LocationWrapper = document.createElement("div");
                        LocationWrapper.className = "ReffTableTDWrapper";
                        LocationTD.append(LocationWrapper);

                        let LocationText = document.createElement("a");
                        LocationText.className = "HyperlinkUnderlineText LabelGreyHeaderSmallerText InterMediumTextFont";
                        LocationText.style.color = "black";
                        LocationText.target = "_blank";
                        LocationText.style.overflow = "hidden";
                        LocationText.style.whiteSpace ="nowrap";
                        LocationText.style.textOverflow = "ellipsis";
                        LocationText.href = ThisDataUserData[i].booking.hotel.category.category_name.toLowerCase() + "/" + window.CurrentCountryID + "/" + ThisDataUserData[i].booking.id_hotel + ".html";
                        LocationText.innerHTML = ThisDataUserData[i].booking.hotel.hotel_name;
                        LocationWrapper.append(LocationText);
                    }
                }
                else
                {
                    let DummyHistoryTR = document.createElement("tr");
                    ReffTableTBody.append(DummyHistoryTR);

                    let DummyHistoryTD = document.createElement("td"); // User Profile ---------------------------
                    DummyHistoryTD.style.width = "35%";
                    DummyHistoryTR.append(DummyHistoryTD);

                    let DummyHistoryWrapper = document.createElement("div");
                    DummyHistoryWrapper.className = "ReffTableTDWrapper";
                    DummyHistoryTD.append(DummyHistoryWrapper);

                    let DummyHistoryIcon = document.createElement("div");
                    DummyHistoryIcon.className = "UserTopProfileIcon";
                    DummyHistoryIcon.style.opacity = 0;
                    DummyHistoryWrapper.append(DummyHistoryIcon);

                    let UserTopProfileIMG = document.createElement("img");
                    UserTopProfileIMG.className = "ImageFullCover";
                    UserTopProfileIMG.src = "/Assets/images/ProfilePicture.jpg";
                    DummyHistoryIcon.append(UserTopProfileIMG);

                    let UserNameText = document.createElement("p");
                    UserNameText.className = "LabelGreyHeaderSmallerText InterMediumTextFont";
                    UserNameText.innerHTML = "---";
                    UserNameText.style.opacity = 0;
                    DummyHistoryWrapper.append(UserNameText);
                }
            }
        }

        // Instantiate Lainnya --------------------------

        if(ThisDataUserData.length > HowManyMaxDisplayRef)
        {
            let RemainingToDisplay = ThisDataUserData.length - HowManyMaxDisplayRef;

            let LoadingHistoryTr = document.createElement("tr");
            ReffTableTBody.append(LoadingHistoryTr);

            let HowManyTD = document.createElement("td");
            HowManyTD.style.width = "100%";
            LoadingHistoryTr.append(HowManyTD);

            let HowManyWrapper = document.createElement("div");
            HowManyWrapper.className = "ReffTableTDWrapper";
            HowManyTD.append(HowManyWrapper);

            let HowManyIconContainer = document.createElement("div");
            HowManyIconContainer.className = "UserTopProfileIcon";
            HowManyWrapper.append(HowManyIconContainer);

            let HowManyText = document.createElement("p");
            HowManyText.className = "LabelGreyHeaderSmallerText InterMediumTextFont";
            HowManyText.innerHTML = RemainingToDisplay + "+";
            HowManyIconContainer.append(HowManyText);

            let LainnyaText = document.createElement("p");
            LainnyaText.className = "LabelGreyHeaderSmallerText InterMediumTextFont";
            LainnyaText.innerHTML = window["LainnyaDotTxt" + window.CurrentCountryID];
            HowManyWrapper.append(LainnyaText);
        }
    }
}
